export function sliders() {
  if ($jq3('.hero-slider').length > 0) {
    const autoplayOn = parseInt($jq3('.hero-slider').data('autoplay')) === 1

    $jq3('.hero-slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 600,
      dots: true,
      arrows: false,
      autoplay: autoplayOn,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnDotsHover: true,
    })
  }

  $jq3('.feature-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 600,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  })

  $jq3('.filtered-property__slider').slick({
    infinite: true,
    slidesToScroll: 3,
    slidesToShow: 3,
    dots: false,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  $jq3('.feature-boxes--default-slider').slick({
    infinite: true,
    slidesToScroll: 3,
    slidesToShow: 3,
    dots: false,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  $jq3('.service-boxes-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    dots: false,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
  })

  $jq3('.netzwerk-slider').slick({
    infinite: true,
    slidesToScroll: 4,
    slidesToShow: 4,
    dots: false,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  $jq3('.feature-boxes--single-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    dots: false,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
  })

  $jq3('.filtered-content__slider').slick({
    infinite: true,
    slidesToScroll: 3,
    slidesToShow: 3,
    dots: false,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  $jq3('.services').slick({
    infinite: true,
    slidesToScroll: 3,
    slidesToShow: 3,
    dots: false,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  $jq3('.contacts__slider').slick({
    infinite: true,
    slidesToScroll: 4,
    slidesToShow: 4,
    dots: false,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  $jq3('.sites-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
  })

  $jq3('.references__slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    speed: 1000,
    waitForAnimate: true,
    easing: 'ease',
  })

  $jq3('.submenu__item--slide-jumplink').on('click', function () {
    const targetSlide = $jq3(this).data('slide-id')
    if (targetSlide !== undefined) {
      $jq3('.sites-slider').slick('slickGoTo', targetSlide)
    }
  })

  $jq3('.reviews').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    speed: 600,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  })
}

$jq3('.location-content__slider').slick({
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 1,
  dots: false,
  arrows: true,
  speed: 1000,
  waitForAnimate: true,
  easing: 'ease',
})
